import { render } from "./Sidebar.vue?vue&type=template&id=5f5f0502&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5f5f0502&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/htdocs/takayama_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5f0502"]])

export default __exports__